/**
 * Shoorah Pods' own vocabulary, mapped onto the panel-wide design tokens in
 * component/common/designSystem/theme.js — the same split breathworkTheme.js
 * uses: only domain meaning lives here, palettes belong to the design system.
 */
import { CHART_COLORS, toneChip, toneLookup } from '../../../../component/common/designSystem';

/**
 * Ordered ramps for the distribution charts. Each is a sequence rather than a
 * set of categories, and each has exactly as many colours as its band list has
 * bands, so a slice never borrows its neighbour's meaning.
 */

// Minutes per play, Under 5 min → Over 40 min. A longer listen is a deeper
// one, so this is a plain shallow → deep ramp.
export const SESSION_LENGTH_RAMP = [
  CHART_COLORS.gray,
  CHART_COLORS.brandSoft,
  CHART_COLORS.brand,
  CHART_COLORS.greenDeep,
  CHART_COLORS.green
];

// Plays per listener, 1 play → 20+ plays. Four bands, same direction.
export const ENGAGEMENT_RAMP = [
  CHART_COLORS.gray,
  CHART_COLORS.brandSoft,
  CHART_COLORS.brand,
  CHART_COLORS.green
];

// Audio vs video are formats, not a sequence, so they take two distinct hues
// rather than a ramp. Unknown only appears when a played pod has since left
// the catalogue.
export const FORMAT_RAMP = [CHART_COLORS.brand, CHART_COLORS.pink, CHART_COLORS.gray];

const formatTone = toneLookup({ audio: 'brand', video: 'accent' });

export const formatChipClass = (label) => toneChip(formatTone(label));
